"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchLanguageSuccess = void 0;
var connected_react_router_1 = require("connected-react-router");
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
var cookies_1 = require("utils/cookies");
var actionTypes = require("@caddigital/sok-reducers/lib/actionTypes/translations");
var constants_1 = require("utils/constants");
var fetchLanguageSuccess = function (action$, store) {
    return action$.pipe((0, operators_1.filter)(function (action) { return action.type === actionTypes.FETCH_SUCCESS; }), (0, operators_1.flatMap)(function (x) {
        (0, cookies_1.setCookie)('language', x.payload.language, constants_1.LANGUAGE_EXPIRES);
        var currLoc = window.location.pathname;
        if (currLoc.startsWith('/sso') ||
            currLoc.startsWith('/authorizing') ||
            currLoc.startsWith('/authorize')) {
            return (0, rxjs_1.empty)();
        }
        var currLang = /^\/([\w]+)\/?/.exec(currLoc);
        if (currLang === null) {
            return (0, rxjs_1.of)((0, connected_react_router_1.replace)("/".concat(x.payload.language)));
        }
        else if (currLang && currLang[1]) {
            var path = currLoc.replace(currLang[1], "".concat(x.payload.language)) +
                window.location.search;
            return (0, rxjs_1.of)((0, connected_react_router_1.replace)(path));
        }
        return (0, rxjs_1.empty)();
    }));
};
exports.fetchLanguageSuccess = fetchLanguageSuccess;
